// #514 Uses the eyou account but keeps authentication failures on the current page.
/* global process */
import axios from "axios";
import store from "@/store";

export const cdkHttp = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  withCredentials: true,
  timeout: 55000,
});
cdkHttp.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) config.headers.Authorization = token;
  const captcha = localStorage.getItem("captchaUuid");
  if (captcha) config.headers["x-captcha-uuid"] = captcha;
  return config;
});
cdkHttp.interceptors.response.use((res) => {
  const captcha = res.headers["x-captcha-uuid"];
  if (captcha) localStorage.setItem("captchaUuid", captcha);
  const renewed = res.headers.authorization;
  if (renewed && renewed.split(".").length === 3) localStorage.setItem("access_token", renewed);
  return res;
});

export async function cdkRequest(action, data = {}) {
  try {
    const res = await cdkHttp.post("web/cdk/" + action + "/", data);
    if (res.data.status !== 10000) throw new Error(res.data.msg || "操作失败");
    return res.data.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem("access_token");
      store.commit("SET_AUTHENTICATED", false);
      store.commit("SET_USER", null);
      store.commit("SET_LOGINMODALTYPE", "login");
      store.dispatch("authModal/showLoginModal");
      error.needsLogin = true;
    }
    error.message = error.response?.data?.msg || error.message || "网络异常，请稍后重试";
    throw error;
  }
}
